<div [style.width.px]="width" id="nothing-found-row">Nothing found</div>
